// extracted by mini-css-extract-plugin
export default {"card":"styles_card__54npr","heading":"styles_heading__7NGcx","done":"styles_done__GaB6f"};